import { TrendingUpRounded } from '@material-ui/icons';
import {
    INIT,
    RESET,
    SET_DIAS,
    SET_DISABLED,
    SET_TIPO_GESTION,
   
} from './types';

export const initialStateDisabled={
    "siniestro":{disabled:false, radio:true},
    "patente": {disabled:false, radio:true},
    "diasInfPendientes": {disabled:false, radio:true},
    "diasRat": {disabled:false, radio:true}
}

export default function buscarReducer(state , action) {
    switch (action.type) {
        case RESET:
            return { ...state,
                siniestro:{...state.siniestro, disabled:false},
                patente:{...state.patente, disabled:false},
                diasInfPendientes:{...state.diasInfPendientes, disabled:false},
                diasRat:{...state.diasRat, disabled:false}
            }
        case INIT:
            return { ...state,
                siniestro:{...state.siniestro, disabled:false},
                patente:{...state.patente, disabled:false},            
                diasInfPendientes:{...state.diasInfPendientes, disabled:false} ,
                diasRat:{...state.diasRat, disabled:false}             
            }
        case SET_DISABLED:
            action.payload.name

            return { ...state,[action.payload.name]:{...[action.payload.disabled], disabled:[action.payload.disabled]} }
           
        default:
            return state
    }
}